<template>
  <div :class="[className, 'chartDiv']"></div>
</template>

<script>
export default {
  name: 'chartsComponent',
  props: {
    className: {
      type: String,
      default: 'chartsComponent'
    }
  },
  data () {
    return {
      options: {},
      chartObject: null
    }
  },
  mounted () {},
  methods: {
    init (options) {
      try {
        this.options = {}
        let chartDom = document.querySelector('.' + this.className)
        this.chartObject = this.$echarts.init(chartDom)
        this.options = Object.assign({}, options)
        if (options && typeof options === 'object') {
          this.chartObject.setOption(options, true)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.chartsComponent {
  width: 100%;
  height: 100%;
}
.chartDiv {
  width: 100%;
  height: 100%;
}
</style>
